export default "44b415f3b0ac1da7.ttf"